import HistorySlider from "./components/history-slider/HistorySlider.vue";
import Timeline from "./components/timeline/Timeline.vue";
import NewsCard from "./components/news-card/NewsCard.vue";
import News from "./components/news/News.vue";
import PeopleCard from "./components/people-card/PeopleCard.vue";
import People from "./components/people/People.vue";
import Partners from "./components/partners/Partners.vue";
import Contact from "./components/contact/Contact.vue";
import LogotypeForm from "./components/logotype-form/LogotypeForm.vue";

const routes = [
  {
    path: "/",
    component: NewsCard,
    name: "NewsCard"
  },
  {
    path: "/news",
    component: News,
    name: "News"
  },
  {
    path: "/people-list",
    component: PeopleCard,
    name: "PeopleCard"
  },
  {
    path: "/people",
    component: People,
    name: "People"
  },
  {
    path: "/timeline",
    component: Timeline,
    name: "Timeline"
  },
  {
    path: "/history",
    component: HistorySlider,
    name: "History"
  },
  {
    path: "/logotype",
    component: LogotypeForm,
    name: "LogotypeForm"
  },
  {
    path: "/partners",
    component: Partners,
    name: "Partners"
  },
  {
    path: "/contact",
    component: Contact,
    name: "Contact"
  }
];

export default routes;
